/*
  Gra "Zbieraj litery" - 5% rabatu za znalezienie hasła dnia.

  Zasada: każdego dnia losujemy hasło z listy słów, a jego kolejne litery
  chowamy na kartach wybranych produktów. Przydział jest deterministyczny -
  wynika z daty, więc każde urządzenie liczy dokładnie to samo bez serwera.

  Czego ten plik NIE robi: nie chroni przed kimś, kto go przeczyta. Cała logika
  jest po stronie przeglądarki, więc osoba, która otworzy źródło, policzy hasło
  bez odwiedzania sklepu. Zabezpieczenia poniżej odsiewają automaty i przypadkowe
  skanowanie, nie zdeterminowanego człowieka. Realną barierą jest to, że kod
  rabatowy wydaje serwer i jest jednorazowy.
*/
(function () {
  'use strict';

  var KLUCZ = 'ciroa:litery';
  var DLUGOSC_HASLA = 10;

  /* Słowa bez polskich znaków - hasło trzeba wpisać z klawiatury, a ogonki
     na telefonie potrafią zniechęcić skuteczniej niż sama gra. */
  var SLOWA = [
    'NAWILZENIE', 'ODZYWIENIE', 'ODPREZENIE', 'BAWELNIANA', 'KASZMIROWA',
    'AKSAMITNA', 'LAGODNOSC', 'PROMIENNA', 'ELEGANCJA', 'DELIKATNA',
    'NATURALNA', 'WITALNOSC', 'LAWENDOWA', 'MIGDALOWA', 'WANILIOWA',
    'CYTRUSOWA', 'SLONECZNA', 'POGODNOSC', 'RADOSNOSC', 'JASMINOWA',
    'OTULAJACA', 'BLYSKOTKA', 'SPOKOJNIE', 'PROMIENIE', 'GLADKOSC',
    'MIEKKOSC', 'SWIEZOSC', 'JEDWABNA', 'CZYSTOSC', 'HARMONIA',
    'SUBTELNA', 'KWIATOWA', 'KOKOSOWA', 'MALINOWA', 'PIANKOWA',
    'WIOSENNA', 'URODZIWA', 'PIEKNOSC', 'MAGNOLIA', 'ORCHIDEA',
    'SATYNOWA', 'PUSZYSTA', 'TULIPANY'
  ];

  /* ---------- liczby pseudolosowe ---------- */

  function hasz(tekst) {
    var h = 2166136261;
    for (var i = 0; i < tekst.length; i++) {
      h ^= tekst.charCodeAt(i);
      h = Math.imul(h, 16777619);
    }
    return h >>> 0;
  }

  function generator(ziarno) {
    var a = ziarno >>> 0;
    return function () {
      a = (a + 0x6d2b79f5) >>> 0;
      var t = a;
      t = Math.imul(t ^ (t >>> 15), t | 1);
      t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
      return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
    };
  }

  /* ---------- doba gry ---------- */

  function dzien(data) {
    var d = data || new Date();
    return d.getFullYear() + '-' +
      String(d.getMonth() + 1).padStart(2, '0') + '-' +
      String(d.getDate()).padStart(2, '0');
  }

  function haslo(dob) {
    var slowo = SLOWA[hasz(dob + '|slowo') % SLOWA.length];
    return slowo.slice(0, DLUGOSC_HASLA);
  }

  /* Zwraca mapę: id produktu -> pozycja litery (0..n-1).
     Tasujemy listę produktów ziarnem z daty i bierzemy tyle pierwszych,
     ile liter ma hasło. Dzięki temu każda pozycja ma dokładnie jednego
     nosiciela i dzień zawsze da się rozwiązać. */
  function przydzial(dob, produkty) {
    var slowo = haslo(dob);
    var kopia = produkty.slice();
    var losuj = generator(hasz(dob + '|tasowanie'));
    for (var i = kopia.length - 1; i > 0; i--) {
      var j = Math.floor(losuj() * (i + 1));
      var pom = kopia[i]; kopia[i] = kopia[j]; kopia[j] = pom;
    }
    var mapa = {};
    for (var k = 0; k < slowo.length && k < kopia.length; k++) {
      mapa[String(kopia[k])] = k;
    }
    return mapa;
  }

  function produkty() {
    var wezel = document.getElementById('ciroa-litery-produkty');
    if (!wezel) return [];
    try {
      var lista = JSON.parse(wezel.textContent);
      return Array.isArray(lista) ? lista : [];
    } catch (e) { return []; }
  }

  /* ---------- postęp gracza ---------- */

  function pusty(dob) {
    return { dzien: dob, litery: {}, odwiedzone: [], kod: null };
  }

  function wczytaj() {
    var dob = dzien();
    var stan;
    try { stan = JSON.parse(localStorage.getItem(KLUCZ) || 'null'); }
    catch (e) { stan = null; }
    /* Nowy dzień to nowe hasło - stare litery przestają cokolwiek znaczyć. */
    if (!stan || stan.dzien !== dob) stan = pusty(dob);
    if (!stan.litery) stan.litery = {};
    if (!Array.isArray(stan.odwiedzone)) stan.odwiedzone = [];
    return stan;
  }

  function zapisz(stan) {
    try { localStorage.setItem(KLUCZ, JSON.stringify(stan)); } catch (e) {}
    document.dispatchEvent(new CustomEvent('ciroa:litery:zmiana', { detail: stan }));
  }

  function odnotujOdwiedziny(id) {
    var stan = wczytaj();
    if (stan.odwiedzone.indexOf(id) === -1) {
      stan.odwiedzone.push(id);
      zapisz(stan);
    }
  }

  function odnotujLitere(pozycja, litera) {
    var stan = wczytaj();
    if (stan.litery[pozycja] === litera) return false;
    stan.litery[pozycja] = litera;
    zapisz(stan);
    return true;
  }

  window.ciroaLitery = {
    dzien: dzien,
    haslo: haslo,
    przydzial: przydzial,
    produkty: produkty,
    wczytaj: wczytaj,
    zapisz: zapisz,
    pusty: pusty,
    odnotujLitere: odnotujLitere,
    odnotujOdwiedziny: odnotujOdwiedziny,
    dlugosc: DLUGOSC_HASLA
  };
})();
